<template>
    <div>
        <app-card
            headerIcon="schedule"
            heading="Continuous Setting"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :footer="true"
            :fullBlock="true"
            :reload="reload"
        >
            <continuous-setting></continuous-setting>
            <v-spacer slot="footer"></v-spacer>
            <v-btn slot="footer" class="mr-2" color="primary" @click="$router.push({ name: 'continuous_setting' })" small>{{ $t("lang.view_all") }}</v-btn>
            <v-btn slot="header" icon small @click="refreshContinuousSetting"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import ContinuousSetting from "App_components/Widgets/ContinuousSetting.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: {
        ContinuousSetting,
    },
    props: {
        refreshMethod: {
            type: Function,
        },
    },
    data() {
        return {
            name: "continuous_setting",
            reload: false,
        };
    },
    computed: {
        ...mapActions(["fetchQualityControl"]),
        ...mapState({
            dashboard_quality_control: (state) => state.quality_control.dashboard_quality_control,
        }),
    },
    methods: {
        async refreshContinuousSetting(refresh = false) {
            this.reload = true;
            if (refresh) {
                await this.$store.commit("commitWorkOrder", {
                    property: "dashboard_work_orders_batches",
                    with: null,
                });
            }

            await this.$store.dispatch("fetchWorkOrder", {
                url: "work_orders/continuous/setting",
                method: "get",
                stateProperty: "dashboard_work_orders_batches",
                dataProperty: "work_orders_batches",
                commit: true,
            });
            this.reload = false;
        },
    },
};
</script>
